import type { JSX } from "react";
import { createFileRoute, useRouter } from "@tanstack/react-router";
import HelpCircle from "@repo/icons/default/HelpCircle";
import Left from "@repo/icons/default/Left";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { NotificationCenterTab } from "@/components/notification/center/notification-center-tab";

const NotificationCenterPage = (): JSX.Element => {
  const router = useRouter();

  const handleAbout = (): void => {
    void router.navigate({ to: "/home/notification-center/about" });
  };

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Notificações" />
        <HeaderButton icon={HelpCircle} onClick={handleAbout} align="end" />
      </HeaderRoot>
      <Page>
        <NotificationCenterTab />
      </Page>
    </>
  );
};

export const Route = createFileRoute("/home/notification-center/")({
  component: NotificationCenterPage,
});
